(() => {
  async function hideEmptyBrands() {
    const cards = [...document.querySelectorAll('[data-shop-brand]')];
    if (!cards.length) return;

    try {
      const products = [];
      const root = window.Shopify?.routes?.root || '/';
      const productFeed = `${root.endsWith('/') ? root : `${root}/`}products.json`;
      for (let page = 1; page <= 10; page += 1) {
        const response = await fetch(`${productFeed}?limit=250&page=${page}`, { headers: { accept: 'application/json' } });
        if (!response.ok) throw new Error('Could not read the live product catalogue');
        const batch = (await response.json()).products;
        if (!Array.isArray(batch)) throw new Error('Unexpected product catalogue response');
        products.push(...batch);
        if (batch.length < 250) break;
      }

      const counts = new Map();
      products.forEach(product => {
        const vendor = String(product.vendor || '').toLowerCase();
        if (vendor) counts.set(vendor, (counts.get(vendor) || 0) + 1);
      });
      cards.forEach(card => {
        const count = counts.get(card.dataset.shopBrand.trim().toLowerCase()) || 0;
        card.hidden = count === 0;
        const countLabel = card.querySelector('small');
        if (countLabel && count) countLabel.textContent = `${count} ${count === 1 ? 'PRODUCT' : 'PRODUCTS'} ↗`;
      });
    } catch {
      cards.forEach(card => {
        const countLabel = card.querySelector('small');
        if (countLabel?.textContent.trim().startsWith('0 PRODUCTS')) card.hidden = true;
      });
    }
  }

  const tabs = [...document.querySelectorAll('[data-shop-browse]')];
  const panels = [...document.querySelectorAll('[data-shop-panel]')];
  if (tabs.length && panels.length) {
    const brandPanel = panels.find(panel => panel.dataset.shopPanel === 'brand');
    let brandFilterPromise;
    const ensureBrandCounts = () => {
      if (!brandFilterPromise) {
        brandPanel?.setAttribute('aria-busy', 'true');
        brandFilterPromise = hideEmptyBrands().finally(() => brandPanel?.removeAttribute('aria-busy'));
      }
      return brandFilterPromise;
    };
    const setMode = mode => {
      const selected = mode === 'brand' ? 'brand' : 'type';
      tabs.forEach(tab => tab.setAttribute('aria-pressed', String(tab.dataset.shopBrowse === selected)));
      panels.forEach(panel => { panel.hidden = panel.dataset.shopPanel !== selected; });
      if (selected === 'brand') ensureBrandCounts();
    };
    tabs.forEach(tab => tab.addEventListener('click', () => setMode(tab.dataset.shopBrowse)));
    if (location.hash === '#brands') setMode('brand');
  }

  const params = new URLSearchParams(location.search);
  const filterForm = document.querySelector('[data-filter-form]');
  const typeSelect = document.querySelector('[data-selection-filter="type"]');
  const brandSelect = document.querySelector('[data-selection-filter="brand"]');
  if (typeSelect) typeSelect.value = params.get('filter.p.product_type') || '';
  if (brandSelect) brandSelect.value = params.get('filter.p.vendor') || '';
  [typeSelect, brandSelect].filter(Boolean).forEach(select => {
    select.addEventListener('change', () => {
      filterForm?.requestSubmit();
    });
  });

  const summary = document.querySelector('[data-selection-summary]');
  const selectedType = params.get('filter.p.product_type');
  const selectedBrand = params.get('filter.p.vendor');
  if (summary && (selectedType || selectedBrand)) {
    summary.hidden = false;
    const prefix = document.createElement('strong');
    prefix.textContent = 'CURRENT SELECTION';
    summary.append(prefix);
    if (selectedType) {
      const type = document.createElement('span');
      type.textContent = `Type: ${selectedType}`;
      summary.append(type);
    }
    if (selectedBrand) {
      const brand = document.createElement('span');
      brand.textContent = `Brand: ${selectedBrand}`;
      summary.append(brand);
    }
    const clear = document.createElement('a');
    const clearUrl = new URL(location.href);
    clearUrl.searchParams.delete('filter.p.product_type');
    clearUrl.searchParams.delete('filter.p.vendor');
    clear.href = clearUrl.toString();
    clear.textContent = 'Clear type + brand';
    summary.append(clear);
  }

  document.querySelectorAll('[data-shop-filter-param][data-shop-filter-value]').forEach(link => {
    const key = link.dataset.shopFilterParam;
    const value = link.dataset.shopFilterValue;
    link.setAttribute('aria-current', String(params.get(key) === value));
    link.addEventListener('click', event => {
      const next = new URL(link.href, location.href);
      for (const [currentKey, currentValue] of params.entries()) {
        if (currentKey.startsWith('filter.') || currentKey === 'sort_by') {
          next.searchParams.set(currentKey, currentValue);
        }
      }
      next.searchParams.set(key, value);
      next.searchParams.set('view', 'shop');
      next.hash = 'catalogue';
      event.preventDefault();
      location.assign(next.toString());
    });
  });
})();
